<template>
    <div class="quill-editor-wrapper">
        <quill-editor
            v-model="content"
            ref="quillEditor"
            :options="editorOption"
            @blur="onEditorBlur"
            @focus="onEditorFocus"
            @ready="onEditorReady"
            @change="onEditorChange"
        />
    </div>
</template>

<script>
    import { quillEditor } from 'vue-quill-editor';
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';

    export default {
        components: {
            quillEditor
        },
        props: {
            value: {
                type: String,
                default: ''
            },
            options: {
                type: Object,
                default: () => ({})
            },
            disabled: {
                type: Boolean,
                default: false
            },
            theme: {
                type: String,
                default: 'snow' 
            }
        },
        data() {
            return {
                content: this.value,
                editorOption: {
                    modules: {
                        toolbar: [
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            [{ 'script': 'sub'}, { 'script': 'super' }],
                            [{ 'indent': '-1'}, { 'indent': '+1' }],
                            [{ 'direction': 'rtl' }],
                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'font': [] }],
                            [{ 'align': [] }],
                            ['clean'],
                            ['link', 'image', 'video']
                        ]
                    },
                    theme: this.theme,
                    placeholder: this.placeholder,
                    readOnly: this.disabled,
                    ...this.options
                }
            }
        },
        watch: {
            value: {
                handler(newVal) {
                    if (newVal !== this.content) {
                        this.content = newVal;
                    }
                },
                immediate: true
            },
            content(newVal) {
                this.$emit('input', newVal);
            },
            disabled(newVal) {
                this.editorOption.readOnly = newVal;
            }
        },
        methods: {
            onEditorBlur(quill) {
                this.$emit('blur', quill);
            },
            onEditorFocus(quill) {
                this.$emit('focus', quill);
            },
            onEditorReady(quill) {
                this.$emit('ready', quill);
            },
            onEditorChange({ quill, html, text }) {
                this.content = html;
                this.$emit('change', { quill, html, text });
            },
            getQuill() {
                return this.$refs.quillEditor.quill;
            },
            getHTML() {
                return this.content;
            },
            getText() {
                return this.$refs.quillEditor.quill.getText();
            },
            getLength() {
                return this.$refs.quillEditor.quill.getLength();
            },
            insertText(index, text, formats = {}) {
                this.$refs.quillEditor.quill.insertText(index, text, formats);
            },
            deleteText(index, length) {
                this.$refs.quillEditor.quill.deleteText(index, length);
            },
            formatText(index, length, formats) {
                this.$refs.quillEditor.quill.formatText(index, length, formats);
            }
        },
        computed: {
            editor() {
                return this.$refs.quillEditor ? this.$refs.quillEditor.quill : null;
            }
        }
    }
</script>

<style scoped>
    ::v-deep .ql-toolbar {
        border-radius: 4px 4px 0 0;
    }

    ::v-deep .ql-editor {
        min-height: 200px;
        line-height: 1.5;
    }

    ::v-deep .ql-container {
        border-radius: 0 0 4px 4px; 
    }
</style>